module.exports = {
  message: {
    system: 'System',
    operationLog: 'OperationLog',
    loginLog: 'LoginLog',
    dashboardManagement: 'DashboardManagement',
    productList: 'ProductList',
    dashboardList: 'DashboardList',
    changeCompany: 'ChangeCompany',
    lang: {
      zh: 'Chinese',
      en: 'English',
    },
  },
};
